module.exports = __webpack_public_path__ + "static/media/ic_head14.9f9a2c1f.png";